export interface UploadInfo{ 
    Issuer: string;
    PatientId: string;
    Surname: string;
    Name: string;
    Sex?: string;
    TaxCode?: string;
    BirthDate?: string;
    OrderDescription?: string;
    OrderDate?: string;
    OrderProvenance: string;
    OrderBusinessUnit?: BusinessUnit;
    OrderNumber?: string;
    OrderArchiveNumber?: string;
    DocumentType?: number;
    DocumentDate?: string;
    SendingApplication?: string;
    DocumentDescription?: string;
    ReferringPhysicianName?: string;
    ReferringPhysicianSurname?: string;
}

export interface JsonDataStructure {
    EventInfo: {
        ExternalApplication: GeneralObject; //description
    },
    Patient: Patient;
    Examinations: Examination[];
    CreatorPhysician: Physician;
    DocumentApproved: Document;
    Store: boolean; //constant
    CorrelationId?: string;
}

export interface Patient {
    Surname: string;
    Name: string;
    Sex: string;
    TaxCode: string;
    BirthDate: string | Date;
    Keys: PatientKeys[];
}

export interface PatientKeys {
    PatientId: string;
    Issuer: string;
    IsExtPatient: boolean; //constant
}

export interface Examination {
    Type: string; // constant
    StepID: string;
    ExamEventType: {
        Description: string;
    }
    ExamDate: string | Date;
    AccessionNumber: string;
    SUID?: string;
    Exam: ExamObject;
    Provenance: GeneralObject; // description
    BusinessUnit?: BusinessUnit;
}

export interface Physician {
    FamilyName: string;
    GivenName: string;
}

export interface Document {
    Number: string;
    Format: string;
    Encoding: string;
    Date: string | Date;
}

export interface GeneralObject {
    Description?: string;
    Code?: string;
}

export interface ExamObject {
    Description: string;
    //Modality: string;
}

export interface BusinessUnit {
    id: string,
    description: string,
    code: number

}

export interface FileView {
    name: string;
    size: number;
    type: string;
    progress: number;
    status: string;
    disableAllButtons ?: boolean;
    disableUploadButton ?: boolean;
    file: File
}

export interface RowActionEvent {
    action: ButtonAction
}

export enum ButtonAction {
    UPLOAD = 'UPLOAD',
    UPLOAD_ALL = 'UPLOAD_ALL',
    DELETE = 'DELETE',
    DELETE_ALL = 'DELETE_ALL'
}

export enum OriginPage {
    VNA_PATIENT_FOLDER = 'vnaPatientFolder',
    EXTERNAL_NOT_DICOM = 'incoming',
    EXTERNAL_DICOM = 'incomingDicom',
    ESTENSARADIO = 'reportReporting',
    ESTENSACARDIO = 'CARDIO',
    TELECONSULTATION = 'teleconsultation',
    EXECUTION_SEARCH = 'executionSearch'
}

export enum UploadStatus {
    UPLOADED = 'Caricato sul PACS',
    ERROR_UPLOAD = 'Errore caricamento',
    TOO_LARGE = 'Dimensione massima superata',
    NOT_SUPPORTED = 'Tipo file non supportato'
}

export interface EstensaField {
    //Modality: string;
    SUID: string;
    Isses: string;
    StepId?: string;
}

export class LoadedDataFromRoute {
    uploadInfo: UploadInfo;
    estensaField?: EstensaField;
    acceptedFormats?: Array<string>;

    constructor(uploadInfo: UploadInfo, otherTypeFileEnabled: boolean, estensaField?: EstensaField) {
        this.uploadInfo = uploadInfo;
        this.estensaField = estensaField;
    }
}
